export const environment = {
  name: 'devEnBW',
  production: false,
  version: '1.0.0.0',
  backendApiUrl: '',
  mockApiUri: '',
  displayName: 'Development Stage'
};
